<template>
  <div>
    <Main/>
  </div>
</template>
<script>
import Main from "../encinos/mapLocation/Main.vue";

export default {
  name: "Menu",
  components: {
    Main,
  },
}
</script>
<style scoped>
</style>